import React, { useState } from "react";
import styles from "./Home.module.css";
import { Link } from "react-router-dom";
import { FaLongArrowAltRight, FaDownload } from "react-icons/fa";
import Projects from "../Projects/Projects";
import Contact from "../Contact/Contact";
import ContactIcons from "../ContactIcons/ContactIcons";

const Home = () => {
  const [isNavToggle, setIsNavToggle] = useState(false);
  return (
    <div className={styles.main}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>Jose Gonzalez Massini</h1>
        <h3 className={styles.subtitle}>Software Engineer | DevOps Enthusiast</h3>
        <ContactIcons />
        <a 
          href="/2026 JOSE-GONZALEZ-MASSINI-SE-RESUME.pdf" 
          download 
          className={styles.resumeDownload}
        >
          <FaDownload /> Download Resume
        </a>
      </div>
      {/* <div className={styles.paragraphContainer}>
        <p className={styles.paragraph}>
        I am a passionate Software Engineer with over four years of experience in developing and deploying full-stack 
        applications and optimizing <button className={styles.codeBlock}>CI/CD</button> pipelines. My expertise spans across technologies such as 
        <button className={styles.codeBlock}>JavaScript</button>, <button className={styles.codeBlock}>React</button>, <button className={styles.codeBlock}>Node.js</button>, 
        <button className={styles.codeBlock}>Python</button>, and <button className={styles.codeBlock}>Go</button> with a strong proficiency in managing databases like 
        <button className={styles.codeBlock}>SQL</button>, <button className={styles.codeBlock}>MongoDB</button>, and <button className={styles.codeBlock}>Redis</button>. 
        I am adept at collaborating with 
        cross-functional teams, streamlining workflows, and enhancing project execution.
        <br /><span className={styles.breakSpace}></span>
        In my recent roles, I've implemented efficient CI/CD pipelines at <button className={styles.codeBlock}>Collins Aerospace</button>, reducing manual errors and downtime. 
        I also led a team at <button className={styles.codeBlock}>LeadWire</button>, where I improved client request handling by 50% and drastically reduced query resolution times 
        using SQL optimizations.
        <br /><span className={styles.breakSpace}></span>
        Beyond my professional experience, I’ve built and deployed full-stack applications like Scriptify and a secure password manager API, 
        showcasing my dedication to security and performance. I’m also the founder of Puerto Rico Cycling, where I built an event automation 
        platform for cycling events.
        <br /><span className={styles.breakSpace}></span>
        With a solid background in development, DevOps, and a deep understanding of best practices in secure web application design, 
        I’m continuously driven to push the boundaries of technology.
        </p>
      </div> */}
            <div className={styles.paragraphContainer}>
        <p className={styles.paragraph}>
        I am a passionate Software Engineer with over four years of experience in developing and deploying full-stack 
        applications and optimizing <strong>CI/CD</strong> pipelines. My expertise spans across technologies such as 
        {" "}<strong>JavaScript</strong>, <strong>TypeScript</strong>, <strong>React</strong>, <strong>Next.js</strong>, <strong>Node.js</strong>, 
        {" "}<strong>Python</strong>, and <strong>Go</strong> with a strong proficiency in managing databases like 
        {" "}<strong>PostgreSQL</strong>, <strong>MongoDB</strong>, and <strong>Redis</strong>. 
        I am adept at collaborating with 
        cross-functional teams, streamlining workflows, and enhancing project execution.
        <br /><span className={styles.breakSpace}></span>
        Currently at <strong>Collins Aerospace</strong> as a Software Engineer II, I deploy vendor applications to Kubernetes environments using Helm charts,
        manage infrastructure provisioning, and serve as Scrum Master for a 5-person team. I've engineered CI/CD pipelines reducing deployment time by 90%.
        Previously at <strong>LeadWire</strong>, I managed a 4-person development team and optimized GraphQL-to-SQL transformations, 
        reducing response times from 15-20 minutes to under 5 seconds (99% improvement).
        <br /><span className={styles.breakSpace}></span>
        Beyond my professional experience, I've built full-stack SaaS applications like <strong>Bookealo</strong>, a multi-tenant booking platform 
        using Next.js, TypeScript, and PostgreSQL with Stripe integration. I've also configured a K3s cluster with Ubuntu as the control plane 
        and Raspberry Pi as worker nodes for containerized microservices, showcasing my dedication to modern DevOps practices.
        <br /><span className={styles.breakSpace}></span>
        With a Computer Engineering degree from UPR Mayagüez and expertise in Kubernetes, AWS, and modern development frameworks, 
        I'm continuously driven to push the boundaries of technology and deliver scalable solutions.
        </p>
      </div>
      <div className={styles.ctaProjectsContainer}>
        {/* <Link className={styles.ctaProjects} to="/projects">
          See Projects <FaLongArrowAltRight />
        </Link> */}
        <Projects isNavToggle={isNavToggle} />
      </div>
      
      <div className={styles.ctaProjectsContainer}>
        {/* <Link className={styles.ctaProjects} to="/projects">
          See Projects <FaLongArrowAltRight />
        </Link> */}
        {/* <Contact
        //  isSubmit={isSubmit} sendEmail={sendEmail} 
        /> */}
      </div>
    </div>
  );
};

export default Home;
